module.exports = __webpack_public_path__ + "static/media/blender.2873e652.svg";